import { getConfig } from '../config/environments';

let initialized = false;

export function initGTM(): void {
  if (initialized) return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const config = getConfig();
  if (!config.enableAnalytics) return;

  const { gtmContainerId, gtmAuth, gtmPreview } = config;
  if (!gtmContainerId || !gtmAuth || !gtmPreview) return;

  type DataLayerWindow = typeof window & { dataLayer: Record<string, unknown>[] };
  const w = window as unknown as DataLayerWindow;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src =
    `https://www.googletagmanager.com/gtm.js?id=${gtmContainerId}` +
    `&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x`;

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  initialized = true;
}
